import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

    public notFoundMessage: string = '404<br/>La página a la que intentas acceder no existe.';

    public returnButtonText: string = 'Volver a la página principal';
    public returnButtonUrl: string = '/home';

    constructor() { }

    ngOnInit() { }

}
